import settingReducer from './reducer';

export function getSettingModule() {
  return {
    // Unique id of the module
    id: 'setting',
    // Maps the Store key to the reducer
    reducerMap: {
      setting: settingReducer,
    },
    // This module uses redux-saga middleware
    // This property will be be used by the SagaExtension
    // to run sagas for the moduleD
    sagas: [],
  };
}
